// extracted by mini-css-extract-plugin
export default {"backgroundChip":"ChipButton_backgroundChip__3S2x0","backgroundChipContained":"ChipButton_backgroundChipContained__4rH-N"};